import validator from 'validator';
import Vue from 'vue';

export default {
  data: function () {
    return {
      matched: ''


    }

  }
  , methods: {
    fnTxtValid: function (valid, txt, nullvalue) {
      return (valid) ? txt : nullvalue;
    },

    // 값이 동일한지 여부 true : false
    fnValidateIsEquals: function (preText, nxtText) {
      let valid = validator.equals(preText, nxtText);
      return valid;
    },

    // 값이 동일한지 여부 값 : nullvalue
    fnValidateTxtEquals: function (preText, nxtText, nullvalue) {
      let valid = validator.equals(preText, nxtText);
      return this.fnTxtValid(valid, nxtText, nullvalue);
    },

    // 값의 포함 여부 true : false
    fnValidateIsContains: function (fulltxt, seed) {
      let valid = validator.contains(fulltxt, seed);
      return valid;
    },


    // 값이 영문자와 숫자 여부 true : false
    fnValidateIsAlphanumeric: function (txt) {
      let valid = validator.isAlphanumeric(txt, 'en-US');
      return valid;
    },

    // 값이 영문자와 숫자 여부 값 : nullvalue
    fnValidateTxtAlphanumeric: function (txt, nullvalue) {
      let valid = validator.isAlphanumeric(txt, 'en-US');
      return this.fnTxtValid(valid, txt, nullvalue);
    },

    // 값이 base64 여부 값 : true : false
    fnValidateIsBase64: function (txt) {
      let valid = validator.isBase64(txt);
      return valid;
    },

    // 값이 base64 여부 값 : txt : nullvalue
    fnValidateTxtBase64: function (txt, nullvalue) {
      let valid = validator.isBase64(txt);
      return this.fnTxtValid(valid, txt, nullvalue);
    },

    // 값이 float 형식 여부 값 : txt : nullvalue
    fnValidateIsFloat(value) {
      let valid = validator.isFloat(value);
      return valid;
    },
    // 값이 float 형식 여부 값 : txt : intvalue
    fnValidateTxtFloat(value, intvalue) {
      let valid = validator.isFloat(value);
      let _intvalue = (intvalue == null || intvalue == undefined || typeof (intvalue) == 'String') ? 0 : intvalue;
      return this.fnTxtValid(valid, value, _intvalue);
    },

    // 값이 int 형식 여부 값 : txt : nullvalue
    fnValidateIsInt(value) {
      let valid = validator.isInt(value);
      return valid;
    },

    // 값이 int 형식 여부 값 : txt : intvalue
    fnValidateTxtInt(value, intvalue) {
      let valid = validator.isInt(value);
      let _intvalue = (intvalue == null || intvalue == undefined || typeof (intvalue) == 'String') ? 0 : intvalue;
      return this.fnTxtValid(valid, value, _intvalue);
    },

    // 값의 length 여부 값 : true : false
    fnValidateIsLength: function (txt, min, max) {
      let valid = validator.isLength(txt, min, max);
      return valid;
    },

    // 값의 length 여부 값 : txt : nullvalue
    fnValidateTxtLength: function (txt, min, max, nullvalue) {
      let valid = validator.isLength(txt, min, max);
      return this.fnTxtValid(valid, txt, nullvalue);
    },

    fnValidateIsEmail: function (txt) {
      let valid = validator.isEmail(txt);
      return valid;
    },

    fnValidateTxtEmail: function (txt, nullvalue) {
      let valid = validator.isEmail(txt);
      return this.fnTxtValid(valid, txt, nullvalue);
    },

    fnValidateIsNull: function (txt) {
      let valid = validator.isNull(txt);
      return valid;
    },

    fnValidateTxtNull: function (txt, nullvalue) {
      let valid = validator.isNull(txt);
      return this.fnTxtValid(valid, txt, nullvalue);
    },

    fnValidateIsEmpty: function (txt) {
      let valid = validator.isEmpty(txt);
      return valid;
    },

    fnValidateTxtEmpty: function (txt, nullvalue) {
      let valid = validator.isEmpty(txt);
      return this.fnTxtValid(valid, txt, nullvalue);
    },

    fnValidateIsAlpha: function (txt) {
      let valid = validator.isAlpha(txt);
      return valid;
    },

    fnValidateIsRegExpMatched: function (txt, matched) {
      let valid = validator.matches(txt, matched);
      return valid;
    },
    fnValidateIsMobileHp: function (txt) {
      let valid = validator.isMobilePhone(txt, 'ko-KR');
      return valid;
    },
    fnValidateIsYouth: function (txt) {
      let _date = new Date();
      let _year = _date.getFullYear();
      let _txt = (txt.length == 4) ? txt : txt.substring(0, 4);
      let _value = parseInt(_year) - parseInt(_txt);
      let vaild = (_value >= 20) ? true : false;
      return vaild;
    },
    fnValidateIsUnderYouth: function (txt) {
      let _date = new Date();
      let _year = _date.getFullYear();
      let _txt = (txt.length == 4) ? txt : txt.substring(0, 4);
      let _value = parseInt(_year) - parseInt(_txt);
      let vaild = (_value >= 14) ? true : false;
      return vaild;
    },
    fnValidateBirthdayOverToday: function (txt) {
      let _date = new Date();
      let _val = new Date(txt.substring(0, 4)+"-"+txt.substring(4,6) + "-" + txt.substring(6,8));
      let vaild = (_val > _date) ? true : false;
      console.log(_date, _val, vaild);
      return vaild;
    },
    fnValidateIsDate: function (txt) {
      if (txt.length == 8 && validator.isInt(txt)) {
        let _date = new Date();
        let _year = _date.getFullYear();
        let _month = _date.getMonth() + 1;
        let _day = _date.getDate();
        let _monthTxt = txt.substring(4, 6);
        let _dayTxt = txt.substring(6, 8);
        let _monthVaild = false;
        let _dayVaild = false;
        if (parseInt(_monthTxt) >= 1 && parseInt(_monthTxt) <= 12) {
          _monthVaild = true;
        }

        if (parseInt(_dayTxt) >= 1 && parseInt(_dayTxt) <= 31) {
          _dayVaild = true;
        }

        let vaild = _monthVaild && _dayVaild ? true : false;
        return vaild;
      } else {
        return false;
      }
    },
    fnValidateBirthdayTxt: function (txt) {
      let _valid = txt;
      if (_valid.length >= 4) {
        let _length = (this.fnValidateIsLength(_valid, 8, 8)) ? true : false;
        let _value = (this.fnValidateIsYouth(_valid)) ? true : false;
        if (!_length) {
          return '생년월일은 8자리 입니다.';
        } else {
          return (!_value) ? '청소년 회원입니다.' : '정상 입력입니다.';
        }
      } else {
        return '생년월일은 8자리 입니다.';
      }
    },
    fnValidateYouthBirthdayTxt: function (txt) {
      let _valid = txt;
      if (_valid.length >= 4) {
        let _length = (this.fnValidateIsLength(_valid, 8, 8)) ? true : false;
        let _value = (this.fnValidateIsYouth(_valid)) ? true : false;
        let _value2= (this.fnValidateBirthdayOverToday(_valid)) ? true: false;
        if (!_length) {
          return '생년월일은 8자리 입니다.';
        } else {

          let regexp = /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/;
          let match = this.fnValidateIsRegExpMatched(_valid, regexp);

          if (match && !_value && !_value2) {
            return '정상 입력입니다.';
          } else if (!match) {
            return '유효하지 않은 날짜입니다.';
          } else if (_value) {
            return '성인 회원입니다.';
          } else if (_value2) {
            return '생년월일은 오늘 이후일 수 없습니다.';
          }

        }
      } else {
        return '생년월일은 8자리 입니다.';
      }
    },
    fnValidateUnderYouthBirthdayTxt: function (txt) {
      let _valid = txt;
      if (_valid.length >= 4) {
        let _length = (this.fnValidateIsLength(_valid, 8, 8)) ? true : false;
        let _value = (this.fnValidateIsUnderYouth(_valid)) ? true : false;
        let _value2= (this.fnValidateBirthdayOverToday(_valid)) ? true: false;
        if (!_length) {
          return '생년월일은 8자리 입니다.';
        } else {

          let regexp = /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/;
          let match = this.fnValidateIsRegExpMatched(_valid, regexp);

          if (match && !_value && !_value2) {
            return '정상 입력입니다.';
          } else if (!match) {
            return '유효하지 않은 날짜입니다.';
          } else if (_value) {
            return '14세 이상 입니다.';
          } else if (_value2) {
            return '생년월일은 오늘 이후일 수 없습니다.';
          }

        }
      } else {
        return '생년월일은 8자리 입니다.';
      }
    },
    fnValidateUnderYouthBirthday: function (txt) {
      let _valid = txt;
      if (_valid.length >= 4) {
        let _length = (this.fnValidateIsLength(_valid, 8, 8)) ? true : false;
        let _value = (this.fnValidateIsUnderYouth(_valid)) ? true : false;
        let _value2= (this.fnValidateBirthdayOverToday(_valid)) ? true: false;
        if (!_length) {
          return false;
        } else {

          let regexp = /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/;
          let match = this.fnValidateIsRegExpMatched(_valid, regexp);

          if (match && !_value && !_value2) {
            return true;
          } else if (!match) {
            return false;
          } else if (_value) {
            return false;

          } else if (_value2) {
            return false;

          }

        }
      } else {
        return false;
      }
    }


    , fnValidateBirthday: function (txt) {
      let _valid = txt;
      if (_valid.length >= 4) {
        let _length = (this.fnValidateIsLength(_valid, 8, 8)) ? true : false;
        if (!_length) {
          return false;
        } else {
          let regexp = /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/;
          let match = this.fnValidateIsRegExpMatched(_valid, regexp);

          return (match) ? true : false;
        }
      } else {
        return false;
      }

    },
    fnValidateCenterOpendayTxt: function (txt) {
      let _valid = txt;
      if (_valid.length >= 4) {
        let _length = (this.fnValidateIsLength(_valid, 8, 8)) ? true : false;
        if (!_length) {
          return '설립일은 8자리 입니다.';
        } else {
          let regexp = /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/;
          let match = this.fnValidateIsRegExpMatched(_valid, regexp);

          return (match) ? '정상 입력입니다.' : '유효하지 않은 날짜입니다.';
        }
      } else {
        return '설립일은 8자리 입니다.';
      }
    },
    fnValidateCenterOpenday: function (txt) {
      let _valid = txt;
      if (_valid.length >= 4) {
        let _length = (this.fnValidateIsLength(_valid, 8, 8)) ? true : false;
        if (!_length) {
          return false;
        } else {
          let regexp = /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/;
          let match = this.fnValidateIsRegExpMatched(_valid, regexp);

          //날짜비교 없음
          /*return (match) ? true : false;*/

          //날짜비교 추가
          if (!match) {
            return false;
          } else {
            // 현재 날짜보다 미래일지 확인하는 추가 로직
            let year = parseInt(_valid.substring(0, 4), 10);
            let month = parseInt(_valid.substring(4, 6), 10) - 1; // JavaScript에서 월은 0부터 시작
            let day = parseInt(_valid.substring(6, 8), 10);

            let inputDate = new Date(year, month, day);
            let currentDate = new Date();

            // 시간 부분은 무시하고 날짜만 비교
            inputDate.setHours(0, 0, 0, 0);
            currentDate.setHours(0, 0, 0, 0);

            return inputDate <= currentDate;
          }

        }
      } else {
        return false;
      }

    },
    fnValidateYouthBirthday: function (txt) {
      let _valid = txt;
      if (_valid.length >= 4) {
        let _length = (this.fnValidateIsLength(_valid, 8, 8)) ? true : false;
        let _value = (this.fnValidateIsYouth(_valid)) ? true : false;
        let _value2= (this.fnValidateBirthdayOverToday(_valid)) ? true: false;
        if (!_length) {
          return false;
        } else if(_value2) {
          return false;
        } else {
          return (!_value) ? true : false;
        }
      } else {
        return false;
      }

    },

    fnValidateUserId: function (txt) {
      let _valid = txt;
      // let _reg = /^[a-zA-Z0-9]{5,19}$/;
      let _reg = /^[A-Za-z0-9+]{6,20}$/; // 영대문자+소문자+숫자
      let _regtwo = /^[A-Za-z+]{6,20}$/;  // 영대문자+소문자

      if (_valid.length >= 6 && _valid.length <= 20) {
        let _int = this.fnValidateIsInt(_valid);
        let _str = this.fnValidateIsAlpha(_valid);
        let _match = this.fnValidateIsRegExpMatched(_valid, _reg);
        let _matchtwo = this.fnValidateIsRegExpMatched(_valid, _regtwo);

        //if(!_int && !_str){
        if (!_int) {

          return (_match || _matchtwo) ? '정상 입력입니다.' : '아이디는 영문자나 영문자,숫자포함입니다.';

        } else {

          return '아이디는 영문자나 영문자,숫자포함입니다.';

        }
      } else {
        return '아이디는 6자리 이상 20자리 이하입니다.'
      }
    },
    fnValidateUserNickName: function (txt) {
      let _valid = txt;

/*    // 기존 유효성검사
      const regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/g;*/
      // 공백 검사 추가
      const regExp = /[{}[\]\/?.,;:|)*~`!^\-_+<>@#$%&\\=('"\s]/g;

      let _match = this.fnValidateIsRegExpMatched(_valid, regExp);

      return (_match) ? '닉네임엔 특수문자나 공백을 쓸 수 없습니다.' : '정상 입력입니다.';

    },
    fnValidatePasswordLength: function (txt) {
      let _valid = txt;
      let _reg = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,20}$/;
      let _length = (this.fnValidateIsLength(_valid, 8, 20)) ? true : false;

      if (_length) {
        let _match = this.fnValidateIsRegExpMatched(_valid, _reg);
        return (!_match) ? '비밀번호는 8자리에서 20자리 영문,숫자,특수문자 조합입니다.' : '';
      } else {
        return '비밀번호는 8자리에서 20자리 영문,숫자,특수문자 조합입니다.'
      }

    },
    fnValidatePassword: function (preTxt, nxtText) {
      let _prevalid = preTxt;
      let _nxtvalid = nxtText;

      let _reg = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,20}$/;
      let _match = this.fnValidateIsRegExpMatched(preTxt, _reg);
      let _valid = this.fnValidateIsEquals(_prevalid, _nxtvalid);

      if (preTxt != null && preTxt != '') {
        if (!_match) {
          return '이전 비밀번호가 형식에 맞지 않습니다.';
        } else if (!_valid) {
          return '입력한 비밀번호와 맞지 않습니다.';
        } else if (_match && _valid) {
          return '비밀번호가 일치합니다.';
        }
      } else {
        return '';
      }

      //return (_valid) ? '정상 입력입니다.' : '비밀번호를 다시 입력해주세요.';
    }
    , fnValidateEmail: function (txt) {
      let _valid = txt;
      //let _match = this.fnValidateIsEmail(_valid);
      let regExp = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
      let _match = (_valid.match(regExp) != null) ? true : false;

      return (_match) ? '정상 입력입니다.' : '이메일을 다시 입력해주세요';
    }
    , fnValidateMobileHp: function (txt) {
      let _valid = txt;
      let _match = this.fnValidateIsMobileHp(_valid);
      return (_match) ? '정상 입력입니다.' : '전화번호를 다시 입력해주세요';
    }
    //팩스 및 전화번호
    , fnValidateTelAndFax: function (txt) {
      if (/^(0(1[0-9]|2|3[1-3]|4[1-4]|5[1-5]|6[1-4]|505|70))(\d{3,4})(\d{4})$/.test(txt)) {
        return true;
      }
      return false;
    }

    //사업자번호
    , fnValidateCenterNumber: function (txt) {
      if (/^\d{10}$/.test(txt)) { /* /^([0-9]{3})-?([0-9]{2})-?([0-9]{5})$/ */
        return true;
      }
      return false;
    }
    // 글자수세기, 공백포함/미포함
    , fnValidateTextLength: function (isBlank, txt, lengthNumber) {
      let _blankpattern = /\r\n/gm, _nonblankpattern = /\s/gm;
      let _primary_txt = txt;
      let _txt = (isBlank) ? _primary_txt.replace(_blankpattern, '\n') : _primary_txt.replace(_nonblankpattern, '');
      return (_txt.length > lengthNumber) ? false : true
    }
    //홈페이지
    , fnValidateHmpg: function (txt) {
      let _valid = this.fnValidateIsRegExpMatched(txt, /^(((http(s?))\:\/\/))([0-9a-zA-Z\-]+\.)+[a-zA-Z]{2,6}(\:[0-9]+)?(\/\S*)?/);
      return (_valid) ? true : false;
    }
  }
}
